/**
 * Mirrors InvoicingHelper::calculateStampDuty on the API so the figure shown
 * while editing an invoice matches the one the server stores.
 *
 * Algerian stamp duty (timbre fiscal) applies to invoices settled in cash: 1%
 * of the amount due, floored at 5 DA and capped at 2 500 DA per the Code du
 * timbre.
 */
export function calculateStampDuty(amount) {
  const due = Number(amount) || 0;

  if (due <= 0) return 0;

  const duty = due * 0.01;

  if (duty < 5) return 5;
  if (duty > 2500) return 2500;

  return Math.round(duty * 100) / 100;
}
